<div class="text-standard-text-secondary flex flex-col items-center gap-6">
  <span class="material-symbols-rounded icon-filled" [style.font-size]="'48px'">
    shopping_cart
  </span>
  {{
    textStore.texts()
      | filterTexts
        : ERelationType.shoppingCartEmptyText
        : EEntityType.shoppingCart
      | language
  }}
</div>
